import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { PhotoInfo } from '../../types/service-insight-types';

@Component({
    selector: 'photos-view-window',
    templateUrl: './photos-view-window.component.html',
    styleUrls: ['./photos-view-window.component.scss'],
    animations: [
        trigger('inOutAnimation', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('.4s ease-out', style({ opacity: 1 })),
            ]),
            transition(':leave', [
                style({ opacity: 1 }),
                animate('.4s ease-in', style({ opacity: 0 })),
            ]),
        ]),
    ],
    standalone: false
})
export class PhotosViewWindow implements OnInit {

  @Input() photosList: PhotoInfo[] = [];
  @Input() groupedKey: any;
  @Input() currentSlideIndex: number = 0;
  @Input() showArrows: boolean = true;
  @Output() closePhotoView: EventEmitter<void> = new EventEmitter();
  fileName: string = '';
  showModal:boolean = false;
  downloadTitle:string = 'Download Image';

  viewReportURL: string = 'https://ecolab.lightning.force.com/lightning/r/WorkOrder/';

  ngOnInit() {}

  showNextSlide(): void {
    this.currentSlideIndex = (this.currentSlideIndex + 1) % this.photosList.length;
  }

  showPrevSlide(): void {
    this.currentSlideIndex = (this.currentSlideIndex - 1 + this.photosList.length) % this.photosList.length;
  }

  onIconCloseClicked(): void {
    this.closePhotoView.emit();
  }

  downloadImage() {
    const currentPhoto = this.photosList[this.currentSlideIndex];
    this.showModal = true;
    this.fileName = `${currentPhoto.endDate}-${currentPhoto.customerName}`;
  }

  handleDownload(downloadOptions: {fileName: string, fileType: string}) {
    const currentPhoto = this.photosList[this.currentSlideIndex];
      if(downloadOptions.fileName && downloadOptions.fileName != "") {
        const xhr = new XMLHttpRequest();
        xhr.responseType = 'blob';
        xhr.onload = function () {
        const blob = xhr.response;
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = encodeURI(url);
        link.setAttribute('download', `${downloadOptions.fileName}.jpg`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      };
      xhr.open('GET', currentPhoto.photoUrl);
      xhr.send();

      this.closeModal();
    }
  }

  closeModal() {
   this.showModal = false;
  }
}
